import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';
import AdminPage from './pages/AdminPage';
import PrivacyPage from './pages/PrivacyPage';
import UnsubscribePage from './pages/UnsubscribePage';
import NotFoundPage from './pages/NotFoundPage';

const router = createBrowserRouter([
  // Routes configuration
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/chat',
    element: <App />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/unsubscribe',
    element: <UnsubscribePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default function AppRouter(): React.ReactElement {
  return <RouterProvider router={router} />;
}
